import PropTypes from "prop-types"
import { get } from "lodash"
import { connect } from "react-redux"
import { FilterDrama } from "@mui/icons-material"
import Header from "modules/home-header"
import withUrlParams from "hocs/withUrlParams"

function DatasetReportHeader({ params, account }) {
  const datasetId = get(params, "datasetId")
  const label = datasetId ? `Data cloud - ${datasetId} entitlements` : "Data cloud entitlements"

  return <Header Icon={FilterDrama} title={label} account={account} />
}

DatasetReportHeader.propTypes = {
  account: PropTypes.string.isRequired,
  params: PropTypes.shape({
    datasetId: PropTypes.string.isRequired,
  }),
}

// Even tough it eventually gets the account passed as a prop, the component
// complains about account being undefined on first load if its not connected
export default connect(() => ({}))(withUrlParams(DatasetReportHeader))
